function AdminLayout({ children }) {
  return (
    <div>
      {/* Admin Sidebar */}

      {children}
    </div>
  );
}

export default AdminLayout;
